import { Component, computed, OnInit, Signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FishingEvent } from '../shared/fishing-event.model';
import { LocalStorageService } from '../shared/local-storage.service';
import { TrawlSet } from '../shared/trawl-set.model';
import { IsDefinedPipe } from '../is-defined.pipe';
/**
 * Observer report showing a per-set summary for trawl and non-trawl groundfish fisheries.
 * Sets are ordered by retrieval time (endDate).
 */
@Component({
    selector: 'app-observer-report',
    templateUrl: './observer-report.component.html',
    styleUrls: ['./observer-report.component.css'],
    standalone: false
})
export class ObserverReportComponent implements OnInit {

  fishery: string = '';
  groundfishSets: Signal<FishingEvent[]>;
  trawlSets: Signal<TrawlSet[]>;

  constructor(
    public dataSync: LocalStorageService,
    public router: Router,
    private route: ActivatedRoute
  ) {
    this.groundfishSets = computed(() =>
      [...this.dataSync.user_trip().sets]
        .filter(s => s.fishery === 'Groundfish')
        .sort((a, b) => {
          const aTime = a.endDate ? new Date(a.endDate).getTime() : 0;
          const bTime = b.endDate ? new Date(b.endDate).getTime() : 0;
          return aTime - bTime;
        })
    );
    
    this.trawlSets = computed(() =>
      [...this.dataSync.user_trawlTrip().sets]
        .sort((a, b) => {
          const aTime = a.endDate ? new Date(a.endDate).getTime() : 0;
          const bTime = b.endDate ? new Date(b.endDate).getTime() : 0;
          return aTime - bTime;
        })
    );
  }
    

  ngOnInit(): void {
    this.fishery = this.route.snapshot.paramMap.get('fishery') ?? 'Groundfish';  
    
  }

}
